


































import Vue from 'vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import { ExceptionalJobCreateModel } from '@/services/GeneratedApi';
import { ValueType } from '@/types';
import ApiConfiguration from '@/classes/ApiConfiguration';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { Base64Utils } from '@/utils';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';

export default Vue.extend({
  name: 'generateExceptionalJob',
  props: {},
  data() {
    return {
      ValueType,
      isLoading: false,
      isLoadingUniqueId: false,
      exceptionalJobCreateModel: { uniqueIdentifier: '' } as ExceptionalJobCreateModel,
      barcodePdf: [] as any[],
      pdfBlobUrl: null as string | null
    };
  },
  computed: {},
  methods: {
    async generateExceptionalJobBarcodes(this: any) {
      try {
        this.isLoading = true;
        this.pdfBlobUrl = null;
        const base64Response = await ApiConfiguration.api().tools.toolsCreateExceptionalJobCreate(this.exceptionalJobCreateModel);

        this.pdfBlobUrl = Base64Utils.previewBase64(base64Response, null);

        requestAnimationFrame(() => this.$refs.printObject.contentWindow.print());

        this.exceptionalJobCreateModel.uniqueIdentifier = '';
      } catch (error) {
        if (error instanceof Error) {
          SnotifyConfiguration.showError(error.message);
        }
      } finally {
        this.isLoading = false;
      }
    },
    async generateUniqueIdAsync(this: any) {
      try {
        this.isLoadingUniqueId = true;
        this.exceptionalJobCreateModel.uniqueIdentifier = await ApiConfiguration.api().tools.toolsExceptionaljobuniqueidList();
      } catch (error) {
        if (error instanceof Error) {
          SnotifyConfiguration.showError(error.message);
        }
      } finally {
        this.isLoadingUniqueId = false;
      }
    }
  },
  components: { MStoreFormInput, MStoreSpinnerButton }
});
